export default "__VITE_ASSET__BYlOU04O__"